import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Esto es "sleep training"?',
  a: 'No. Esto no es un método para "entrenar" a tu bebé a dormir solo. Es un sistema de guiones para que TÚ sepas qué hacer en cada despertar sin improvisar. Enfoque suave, sin llanto controlado, sin rigidez.'
}, {
  q: '¿Funciona si doy pecho / lactancia materna?',
  a: 'Sí. Las rutas están diseñadas para funcionar con lactancia materna, fórmula o mixta. La Ruta A (hambre/toma) tiene indicaciones específicas para cada caso.'
}, {
  q: '¿En qué formato viene?',
  a: 'PDF descargable (40–60 páginas) + tarjetas imprimibles que puedes dejar en tu mesa de noche + tracker de 14 noches. Todo listo para imprimir o leer en el celular.'
}, {
  q: '¿Cuándo lo recibo?',
  a: 'Inmediatamente después del pago. Recibes un email con el enlace de descarga. Puedes usarlo esta misma noche.'
}, {
  q: '¿Y si mi bebé tiene más de 12 semanas?',
  a: 'Este sistema está optimizado para 0–12 semanas, que es la etapa más intensa de despertares. Si tu bebé tiene 3–5 meses, muchos principios aplican, pero los guiones están calibrados para recién nacidos.'
}];
function FAQItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="border-b border-[#e2e8f0] last:border-b-0" data-id="element-73">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between py-5 text-left gap-4 cursor-pointer" data-id="element-74">
        <span className="font-serif text-lg text-[#0f172a] font-medium" data-id="element-75">
          {q}
        </span>
        <motion.div animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="shrink-0" data-id="element-76">
          <ChevronDown className="w-5 h-5 text-[#94a3b8]" data-id="element-77" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-78">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-79">
            <p className="pb-5 text-[#475569] leading-relaxed pr-8" data-id="element-80">{a}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  return <section className="w-full bg-white py-20 px-4" data-id="element-81">
      <div className="max-w-2xl mx-auto" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-83">
          <h2 className="font-serif text-3xl md:text-4xl text-[#0f172a] mb-10 text-center" data-id="element-84">
            Preguntas Frecuentes
          </h2>
          <div className="bg-[#faf7f2] rounded-2xl p-6 md:p-8 border border-[#f1f5f9]" data-id="element-85">
            {faqs.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} data-id="element-86" />)}
          </div>
        </motion.div>
      </div>
    </section>;
}